<div class="qloc-card {{class}}">
    <div class="qloc-card-content">
        <h1 class="mb-3" *ngIf="title">{{title}}</h1>
        <ng-content></ng-content>
    </div>
    <div class="qloc-card-footer" *ngIf="footer">{{footer}}</div>
</div>